import { isArray } from 'lodash';

const sortSelectOptions = (options) => {
  const checkedOptions = options.filter((opt) => opt.checked);
  const sortedCheckedOptions = checkedOptions.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));

  const uncheckedOptions = options.filter((opt) => !opt.checked);
  const sortedUncheckedOptions = uncheckedOptions.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));

  return [...sortedCheckedOptions, ...sortedUncheckedOptions];
};

const getRevieweeOptions = ({
  treeList = [],
  revieweeAccounts = [],
  selected
}) => {
  const selectedReviewees = [];

  if (isArray(selected)) {
    selectedReviewees.push(...selected);
  } else if (selected) {
    selectedReviewees.push(selected);
  }

  if (!treeList.length && !revieweeAccounts.length) {
    return [];
  }

  const revieweeOptions = [];
  revieweeAccounts.forEach((reviewee) => revieweeOptions.push({
    value: reviewee._id,
    label: reviewee.name,
    data: reviewee,
    checked: isArray(selectedReviewees)
      ? selectedReviewees.find((opt) => opt.value === reviewee._id)
      : false
  }));

  selectedReviewees.forEach((option) => {
    const foundOption = revieweeOptions.find((opt) => opt.value === option.value);
    if (!foundOption) {
      revieweeOptions.push({
        value: option.value,
        label: option.label,
        checked: true
      });
    }
  });

  const sortedOptions = sortSelectOptions(revieweeOptions);

  return sortedOptions;
};

export {
  getRevieweeOptions,
  sortSelectOptions
};
